import React from "react";

import styled from "@emotion/styled";
import { useFormikContext } from "formik";

import { CheckboxWithUnorderedList } from "shared/components/Form";
import Icon from "shared/components/Icon";
import Tooltip from "shared/components/Tooltip";
import { RegularText, WeakText } from "shared/components/Typography";
import Well from "shared/components/Well";
import { useActiveUser } from "shared/hooks/api";

import { LabelIconContainer, StyledSkeleton as Skeleton } from "./styled";

const CustomerNote = styled.div`
  padding-top: 40px;
`;

const CheckboxFlush = styled.div<{ flushTop?: boolean }>`
  ${({ flushTop }) =>
    flushTop &&
    `
    > div {
      padding-top: 8px;
    }
  `}
`;

const TOOLTIP =
  "Checks the applicant's identity and SSN for signs of synthetic or stolen identity before they continue the application.";
const CUSTOMER_NOTE =
  "Contact your VERO Customer Success Manager to change this setting.";

interface SentilinkIdentificationToggleProps {
  id: string;
  field: string;
  loading?: boolean;
  disabled?: boolean;
}

const SentilinkIdentificationToggle = ({
  id,
  field,
  loading,
  disabled,
}: SentilinkIdentificationToggleProps) => {
  const { values, setFieldValue } = useFormikContext();
  const { activeUser } = useActiveUser();
  const isInternal = Boolean(activeUser?.isInternal);

  return (
    <Skeleton loading={loading}>
      {!isInternal && (
        <CustomerNote>
          <RegularText light>{CUSTOMER_NOTE}</RegularText>
        </CustomerNote>
      )}
      <CheckboxFlush flushTop={!isInternal}>
        <CheckboxWithUnorderedList
          id={id}
          label={
            <LabelIconContainer alignItems="center">
              <span>
                Identity Risk Check{" "}
                <WeakText light>(SentiLink)</WeakText>
              </span>
              <Tooltip title={<Well noBorder>{TOOLTIP}</Well>}>
                <Icon.InfoIcon className="extra-info" />
              </Tooltip>
            </LabelIconContainer>
          }
          value={Boolean(values[field])}
          disabled={disabled || !isInternal}
          onChange={(checked) => setFieldValue(field, checked)}
        />
      </CheckboxFlush>
    </Skeleton>
  );
};

export default SentilinkIdentificationToggle;
